import { useEffect, useState } from 'react';
import { AlertSection } from '../CustomAlertThresholdFilter';
import { useFetchAlertThresholds } from '@/hooks';

export const useAlertFilterDropDown = (skip = false) => {
  const data: AlertSection[] = [
    {
      type: 'section',
      label: 'Alert state',
      items: [
        { id: 'open', title: 'Open' },
        { id: 'dismissed', title: 'Dismissed' },
        { id: 'resolved', title: 'Resolved' },
      ],
    },
    {
      type: 'section',
      label: 'With AI',
      items: [
        { id: 'processing', title: 'Processing' },
        { id: 'needs_attention', title: 'Needs attention' },
        { id: 'resolved_via_ai', title: 'Resolved via AI' },
      ],
    },
    {
      type: 'section',
      label: 'Critical alerts',
      toggleKey: 'showCritical',
      colorDot: '#DE1135',
      items: [
        {
          id: 'temperature_excursion_detected',
          title: 'Temperature excursion',
        },
        { id: 'viability_window_exhausted', title: 'Viability window expired' },
      ],
    },
    {
      type: 'section',
      label: 'At-risk alerts',
      toggleKey: 'showAtRisk',
      colorDot: '#F6BC2F',
      linkedIds: [],
    },
  ];

  const { alertThreshold } = useFetchAlertThresholds(null, skip);
  const [fullAlertFilterConfig, setFullAlertFilterConfig] = useState(data);

  useEffect(() => {
    if (!alertThreshold || skip) return;
    const linkIds = alertThreshold
      .flatMap((x) => x.alerts)
      .filter((x) => x.is_critical_type === false)
      .map((x) => x.alert_type);
    const dynamicArr = alertThreshold.map((element) => ({
      type: 'category',
      label: element.phase_display,
      items: element.alerts
        .filter((alert) => alert.is_critical_type === false)
        .map((alert) => ({
          id: alert.alert_type,
          title: alert.alert_name,
        })),
    }));
    setFullAlertFilterConfig((prev) => {
      const updated = [...prev];

      updated[3] = {
        ...updated[3],
        linkedIds: linkIds,
      };

      return [...updated.slice(0, 4), ...dynamicArr];
    });
  }, [alertThreshold, skip]);

  return fullAlertFilterConfig;
};
